<template>
  <section class="section section-shaped section-lg my-0">
    <div class="shape shape-style-1 bg-gradient-default">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="container pt-lg-md">
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <card type="secondary" shadow
                header-classes="bg-white pb-5"
                body-classes="px-lg-5 py-lg-5"
                class="border-0">
            <template>
              <div v-if="login_errado" class="alert alert-danger" role="alert">
                Número de inscrição ou CPF inválido.
              </div>
              <div class="text-muted text-center mb-3">
                <small>Entre com:</small>
              </div>
              <div class="btn-wrapper text-center">
              </div>
            </template>
            <template>
              <form @submit.prevent="envia_login" role="form">
                <base-input v-model="username" alternative
                            class="mb-3"
                            v-mask="'#######-#'"
                            placeholder="Número de inscrição"
                            addon-left-icon="ni ni-single-02">
                </base-input>
                <base-input v-mask="'###.###.###-##'" v-model="password" alternative

                            placeholder="CPF"
                            addon-left-icon="ni ni-badge">
                </base-input>

                <div class="text-center">
                  <base-button native-type="submit" type="primary" class="my-4">Entrar</base-button>
                </div>
              </form>
            </template>
          </card>
          <div class="row mt-3">
            <div class="col-6">
              <a href="#" class="text-light">
                <!--                <small>Esqueci minha senha</small>-->
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from 'axios';
import {useRouter} from 'vue-router';
import Vue from 'vue'
import vueCrypt from 'vue-crypt'
import {cpf} from "cpf-cnpj-validator";

export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: '',
      login_errado: false,
      logins: [{cpf: 321., num_cand: 123}]
    }
  },
  methods: {
    envia_login: async function () {

      const encryptedText = this.CryptoJS.AES.encrypt("Hi There!", 'secret key 123').toString()
      const decryptedText = this.CryptoJS.AES.decrypt('U2FsdGVkX1+rGzJrqd1xvB4s0Sxxmcl9dbo4sUwcMsE=', 'secret key 123').toString(this.CryptoJS.enc.Utf8)

      const encrypt = (texto) => {
        return this.CryptoJS.AES.encrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString()
      }
      const decrypt = (texto) => {
        return this.CryptoJS.AES.decrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString(this.CryptoJS.enc.Utf8);
      }

      const gera_file_name = (cpf, num_cand) => {

        let candidato = {CPF: cpf, NUMEROINSC: num_cand}
        let cod_projeto = '2106_pt'
        let codigo_meio = candidato.CPF.replace(/\./g, '').replace('-', '') * 7919;
        codigo_meio = codigo_meio.toString()

        let codigo_arquivo = parseInt(codigo_meio.substring(0, 5)) * parseInt(candidato.NUMEROINSC.replace('-', '')) * 13 + '_'
            + String.fromCharCode(65 + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[1]))
            + String.fromCharCode(parseInt(codigo_meio[4] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[7] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[7]))
            + '-'
            + String.fromCharCode(parseInt(codigo_meio[0] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))
            + String.fromCharCode(parseInt(codigo_meio[5] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[8]))
            + '_'
            + String.fromCharCode(parseInt(codigo_meio[2] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[6]))
            + String.fromCharCode(parseInt(codigo_meio[6] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))

        return codigo_arquivo + '.pdf';
      }


      let cands = [{"num_cand":"U2FsdGVkX1/PMb/b3zQREozhYI+/JhTMistKOiopm1U=","cpf":"U2FsdGVkX1+GR2GefgJNnzmhcIgV5cD7r0eKPvNEnes="},{"num_cand":"U2FsdGVkX1/ikJGp+BMB2EcszUvgjzovh8SrrhG6zAc=","cpf":"U2FsdGVkX19YudCO1GA8gsNE/2POnujOf7WYgpVSvBA="},{"num_cand":"U2FsdGVkX1/0lKIBNOrN7qv6TnYNK2f6z3XnlwW6vKM=","cpf":"U2FsdGVkX18axhL1v8EjOAc4PMNR1EVKBCdOU9Q5o3w="},{"num_cand":"U2FsdGVkX1/thD6ppFDqndEHGGYBpy5Hz+JpiyYlDqw=","cpf":"U2FsdGVkX1+mzWwKljRMy3Gp0rXTQIXlY1b1mcul6yI="},{"num_cand":"U2FsdGVkX1+hIH4VpeO9enczvzor9JAN1fdfDtETbsA=","cpf":"U2FsdGVkX1+tS8Ah3Ldk8ewEBFpmh8NXEtBQv5astwU="},{"num_cand":"U2FsdGVkX19SDekNKNWhrJL1fQLcSRVuaVSzDWzfgGA=","cpf":"U2FsdGVkX1+JmnPClDvcmy95E8EUlFFUMrycVv1p33g="},{"num_cand":"U2FsdGVkX1+SOa+TcP8tOJXQRjqOlEPI/+MAB66prz4=","cpf":"U2FsdGVkX18X1gwD9EdtbbciKvjthJ8xphAYF8fho4w="},{"num_cand":"U2FsdGVkX18VcFsQ/8f6KuUhAdvxN0esQYZNsreq+jE=","cpf":"U2FsdGVkX1+aaD890n29cRl3MH1AG+ZOsPXHhgltz7U="},{"num_cand":"U2FsdGVkX18egyyz+/4RaYEh/ooO/H7tkANk/ksOR1Y=","cpf":"U2FsdGVkX1/w5j7fXKiKz+26+qfIbbqaUVod8HGvQcQ="},{"num_cand":"U2FsdGVkX19wE7M/pjqRL1iTNtX+9Dk6KAOfKAR4pwk=","cpf":"U2FsdGVkX1+9QBdtxu0eIiVdnu+90vluWzH34itzFZI="},{"num_cand":"U2FsdGVkX19FTYIGtkaJkWFJOhkVJqius7IPRN2R6K4=","cpf":"U2FsdGVkX1919raNSOdng7MEpEMP/OAGKrG++RICRR8="},{"num_cand":"U2FsdGVkX184LMCkQRT84FJQK9SDL+1YgFsuAiYQFjk=","cpf":"U2FsdGVkX1+KdZvunuF13uq5KffYF17uaMMG0DBK42c="},{"num_cand":"U2FsdGVkX1+ghC2S8y7NU6UJ4NXL3lLJGFBOS1o7qEk=","cpf":"U2FsdGVkX1/lv2dkOlDZ7WLglbUb8hDZ2JhgUtAcwm8="},{"num_cand":"U2FsdGVkX1/XhAx7YgzFDrtkdu2UjYFXkfg+R6cWZLg=","cpf":"U2FsdGVkX1+q+ax5NoEBVYwxYavSswIGFyUrKqedKuI="},{"num_cand":"U2FsdGVkX18rXudGoI7qnWAJQ9TLGDHKe7x1lv9+d+s=","cpf":"U2FsdGVkX18TDWg/dIW9DHshihKAjZNTsvJxgTjcvcU="},{"num_cand":"U2FsdGVkX1/4Z7r9JXbukU5wnGQRt3vkya7mc6bTrf4=","cpf":"U2FsdGVkX18YnG5yl6qTSPmktcD9GU6lWI/q2rOPKWI="},{"num_cand":"U2FsdGVkX1+Hf4kUsW6hNzPuksOHdGmYW85kvL9Buzo=","cpf":"U2FsdGVkX1/DFKITxCPpiKJjm4euYJgg9ke3sAemCE0="},{"num_cand":"U2FsdGVkX19nsEsM/MTh1kZsi9qYyRCHrKXa6Y6lVrQ=","cpf":"U2FsdGVkX1+qLiU1mMklp5DwwzbY7MZikMoXABCuj9A="},{"num_cand":"U2FsdGVkX18BvIcZ9wh4FJozgICntt7OKJdzkXcDsBE=","cpf":"U2FsdGVkX19qLRx0xbo8vuwzPYuCrlXNnt9pvh3CBYc="},{"num_cand":"U2FsdGVkX19DDeZp6vXol16T3aO6AHfeKx6ea2NTjnM=","cpf":"U2FsdGVkX1+6tL8OJUMX58CvvqSGAd9o715337UHhCU="},{"num_cand":"U2FsdGVkX1+GhEos+1CY0OEcegQf37/43N+neeO6qPU=","cpf":"U2FsdGVkX1/POL1fNUw9wXrFOo2ZMzpaqKbUonWrpuY="},{"num_cand":"U2FsdGVkX18E8zshQW2uFXzuld1BbvpzETuKSC/ZE9k=","cpf":"U2FsdGVkX1+KD4botLmteiYShqZTgpgz7miJZn01TSo="},{"num_cand":"U2FsdGVkX1/co5nemdKBgGWm/4iA8Jl+n2ePFZQrRTk=","cpf":"U2FsdGVkX1+mTS/OKEZ7NthoQjWqmh5uE1FyBH1+UMk="}]

      try {
        let concurso = this.$route.params.concurso;
        localStorage.setItem('concurso', concurso);

        for (let login of cands) {
          let num_cand_decripted = decrypt(login.num_cand);
          let cpf_decripted = decrypt(login.cpf);

          // console.log(num_cand_decripted,cpf_decripted)
          if (num_cand_decripted == this.username && cpf_decripted == this.password) {
            console.log(`Logged`)
            let nome_arquivo = (gera_file_name(cpf_decripted, num_cand_decripted))
            nome_arquivo = nome_arquivo.replace(/\x00/g, '-');


            // alert(`Logou`);
            let url = (`https://fs.ibfc.org.br/arquivos/2217/rec_insc/${nome_arquivo}`)
            return window.location = url;
          }
        }

        throw new Error(`Login inválido`);


      } catch (error) {
        console.log(error);
        this.login_errado = true;
      }
    }
  }
};
</script>
<style>
</style>
